import * as svg from "../../../assets/logo-icon-square.svg";

import {iconBuilder} from "./iconBuilder";

export const HostToolsLogoIcon = iconBuilder(svg, "HostToolsLogo", "0 0 75.6 75.6");
